/* eslint-disable no-param-reassign, func-names */

(($) => {
  $.fn.responsiveTable = function () {
    this.each((i, el) => {
      const $el = $(el);
      const titles = $el.find('th').map((j, th) => $(th).text());
      $el.find('tr').each((k, tr) => {
        $(tr).find('td').each((l, td) => {
          $(td).attr('data-title', titles[l]);
        });
      });
    });
  };
})(window.jQuery || jQuery);



// WEBPACK FOOTER //
// ./scripts/utils/table-responsive.js